import React, { createContext, useContext, useState, useEffect } from 'react';

const QuoteContext = createContext();

export const useQuote = () => {
  const context = useContext(QuoteContext);
  if (!context) {
    throw new Error('useQuote must be used within QuoteProvider');
  }
  return context;
};

export const QuoteProvider = ({ children }) => {
  const [quoteItems, setQuoteItems] = useState(() => {
    const saved = localStorage.getItem('procloudQuote');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('procloudQuote', JSON.stringify(quoteItems));
  }, [quoteItems]);

  const addToQuote = (product, quantity = 1) => {
    setQuoteItems(prev => {
      const existingItem = prev.find(item => item.product_code === product.product_code);
      if (existingItem) {
        return prev.map(item =>
          item.product_code === product.product_code
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prev, { ...product, quantity }];
    });
  };

  const updateQuantity = (productCode, quantity) => {
    if (quantity <= 0) {
      removeFromQuote(productCode);
      return;
    }
    setQuoteItems(prev =>
      prev.map(item =>
        item.product_code === productCode ? { ...item, quantity } : item
      )
    );
  };

  const removeFromQuote = (productCode) => {
    setQuoteItems(prev => prev.filter(item => item.product_code !== productCode));
  };

  const clearQuote = () => {
    setQuoteItems([]);
  };

  const getTotalItems = () => {
    return quoteItems.reduce((total, item) => total + item.quantity, 0);
  };

  return (
    <QuoteContext.Provider
      value={{
        quoteItems,
        addToQuote,
        updateQuantity,
        removeFromQuote,
        clearQuote,
        getTotalItems
      }}
    >
      {children}
    </QuoteContext.Provider>
  );
};
